export { default } from './Course';
export type { Props } from './Course';
